import alan from '../static/images/sectionTalking/2018/alan.png';
import alanPhoto from '../static/images/sectionTalking/2018/img-alan.png';
import huichen from '../static/images/sectionTalking/2018/huichen.png';
import huichenPhoto from '../static/images/sectionTalking/2018/img-huichen.png';
import joy from '../static/images/sectionTalking/2018/joy.png';
import joyPhoto from '../static/images/sectionTalking/2018/img-joy.png';
import yachu from '../static/images/sectionTalking/2018/yachu.png';
import yachuPhoto from '../static/images/sectionTalking/2018/img-yachu.png';
import daisy from '../static/images/sectionTalking/2018/daisy.png';
import daisyPhoto from '../static/images/sectionTalking/2018/img-daisy.png';
import cathy from '../static/images/sectionTalking/2018/cathy.png';
import cathyPhoto from '../static/images/sectionTalking/2018/img-cathy.png';
import james from '../static/images/sectionTalking/2018/james.png';
import jamesPhoto from '../static/images/sectionTalking/2018/img-james.png';
import sophia from '../static/images/sectionTalking/2018/sophia.png';
import sophiaPhoto from '../static/images/sectionTalking/2018/img-sophia.png';
import jiudi from '../static/images/sectionTalking/2018/jiudi.png';
import jiudiPhoto from '../static/images/sectionTalking/2018/img-jiudi.png';

export default [
    {
        name: "ALAN",
        position: "Front-End Developer",
        img: alan,
        photo: alanPhoto,
        article: `
            <p>大家好 我是 Alan</p>

            <p>雖然大學有接觸過基礎的程式，但是實際深入應用上不是很了解，為了在大學畢業前培養出實力與自信，所以賭一把投下了履歷，最後也很幸運地進來了新芽，為我的職涯道路上立下了重要的里程碑。</p>

            <p>在實習的一年當中，除了接觸到最新最潮的專案架構，同時也了解一個專案、一間公司的營運模式與工作架構，這裡所有的事物都讓我大開眼界，而身在專案組的我從中學習如何有效運用時間，並對專案負責，同時在溝通能力上也更進了一步。</p>

            <p>工作之餘，生活上也有很多有趣的事，像是每年一度的 Outing 會議，下班後的新芽麻將大賽，每季的電影之夜，最後就是我最喜歡的健身補助與大大小小運動社團！</p>

            <p>最後我覺得新芽是一間非常有潛力的新創，mentor 們都很 nice ! 如果想當很潮的工程師可以來試試看！</p>
        `,
    },
    {
        name: "HUICHEN",
        position: "Project Management",
        img: huichen,
        photo: huichenPhoto,
        article: `
            <p>我想我無法用言語表達能進來新芽實習有多幸運。<br>實習，不只是專業技能的學習、職涯規劃，更多的是自我價值的探索。</p>
            <p>在進來這裡之前，我一直都不是很確定自己想成為一個什麼樣的人，同時也十分懷疑自己的能力。<br>新芽給予我許多的機會，循序漸進地讓我了解這份工作，不著急也不拖遲，剛剛好的速度，剛剛好的學習量。完善的實習制度，充滿耐心的 mentor，新芽用心的培育著實習生，並且期待每個人的成長。</p>
            <p>公事上，同事總是不吝於給予協助及指導；私底下的大家也不曾冷漠，遇到挫折互相鼓勵，遇到快樂一起慶祝。</p>
            <p>在這裡，我找到了屬於我自己的定位；在這裡，我獲得了自我價值的肯定；在這裡，我遇到了許多溫暖的同事。</p>
            <p>人生中總是有幾個肯定跟幾個不肯定，我可以肯定的說：這份實習實在太值得。<br>非常感謝新芽給我的機會，若你與曾經的我一樣，正努力尋找適合自己的實習，不妨來試試吧！收穫絕對是你意想不到的。</p>
        `,
    },
    {
        name: "DAISY",
        position: "Front-End Developer",
        img: daisy,
        photo: daisyPhoto,
        article: `
            <p>哈囉！我是新芽的前端實習生 Daisy。</p>
            <p>在大二那年接觸了 UI design 後，才意外地掉進 coding 的坑裡。在自學遇到瓶頸時，很幸運的來到新芽，真正享受前端開發這條路。</p>
            <p>一個人走得快，一群人則能走得更遠。在新芽，寫 code 從來不是孤單的事。這裡有對新手友善的學習環境，也有豐富的專案可以參與。</p>
            <p>記得剛開始 React 寫得零零落落時，主管在 code review 後給了很多實作上的建議，對於我各種弱弱的問題也耐心解答。也在新芽第一次參與中型以上網站的開發。</p>
            <p>在新芽實習短短不到一年，就累積許多在學校學不到的實作經驗，很感謝新芽的大家各種窩心的協助。</p>
            <p>更佛心的小確幸是，這裡除了有不定期的聚餐、社團活動來拓展宅宅的生活圈以外，每天都有好吃又大碗的午餐、零食，冰箱打開總是滿滿的奶茶。</p>
            <p>可見，新芽實習讓你充實的不只心靈跟腦袋，還有體重呀！</p>
        `,
    },
    {
        name: "JOY",
        position: "Back-End Developer",
        img: joy,
        photo: joyPhoto,
        article: `
            <p>嗨 我是 Joy</p>

            <p>大學時一直有在關注新芽這家公司，終於在研究所幸運的成為了實習生。因為是第一次實習，所以很多事情都顛覆我以往的想像，也深深了解自己還有很多的不足。</p>

            <p>這邊要謝謝我的Mentor不遺餘力的指導我，回答我的各種問題，幫助我完成每一次的課題。其他的後端前輩們也非常熱心，有任何問題請教他們的話都可以得到很棒的建議。<br>雖然還有很多要進步的空間，但和剛進新芽的自己比較後，覺得成長了許多，這全多虧了公司提供的學習機會。</p>

            <p>另外，在新芽，各種資訊都是十分透明的，通過每一次的例會，實習生可以了解到產品、公司的運作模式及發展，也可以從前輩們之間的技術交流學習新知，真的收穫良多！</p>
            <p>公司舉辦的各種活動，舉凡電影之夜、麻將大賽都十分的有趣，更凝聚了大家的感情，讓大家在工作之餘能盡情放鬆，建立愉快的工作氛圍。</p>

            <p>真的！不要猶豫了！把握機會，快快加入新芽大家庭吧～～～</p>
        `,
    },
    {
        name: "YACHU",
        position: "Back-End Developer",
        img: yachu,
        photo: yachuPhoto,
        article: `
            <p>能在新芽當實習生真的很幸福，在實習過程中Mentor循序漸進的帶領我熟悉新芽的開發環境，在沒有壓力的情況下成長，從小功能的開發到自己負責一個小專案，真的非常有成就感，遇到問題後端的前輩們也都非常耐心的回答、給我建議，也很喜歡開會時互相分享新技術或自己踩過的雷避免其他人踩到，互助互惠和樂融融。</p>

            <p>更重要的是在這裡大家每天看起來都在玩樂、打Switch、抓寶可夢、吃零食、吃午餐、躺在遊樂區，鬧哄哄的充滿歡笑，但工作起來又非常認真有效率！</p>
            <p>下班後還可以一起運動、吃美食、看電影，在outing一起喝個爛醉，雖然我因為交換的關係只能在新芽實習半年，但這半年絕對是大學最開心的時光之一，打到這裡已想念，不要猶豫快報名吧。</p>
        `,
    },
    {
        name: "CATHY",
        position: "Project Management",
        img: cathy,
        photo: cathyPhoto,
        article: `
            <p>嗨嗨 我是小凱西😉</p>

            <p>一直覺得自己能進入新芽當實習生是件很幸福的事情，這裡的人們都很友善（顏值也很高）、工作環境舒適、工作挑戰也都很有趣。雖然我比其他第五屆的實習生晚進來了一點，但大家對我的包容與友善使我可以馬上融入大家，真的很慶幸自己當時把握住機會投了履歷。</p>

            <p>專案管理實習生的工作內容主要在擔任 PM 的小助理，可以跟著 PM 走過整個專案的流程。印象很深刻是會請 Sales 或 SurveyCake Team 來開小 workshop，使我們能更加瞭解公司狀況而能更好地代表公司與客戶交流。</p>

            <p>說了這麼多，快來加入新芽體會更多有趣的時光吧！</p>
        `,
    },
    {
        name: "JAMES",
        position: "Accountant / Administrator",
        img: james,
        photo: jamesPhoto,
        article: `
            <p>HI!! 我是高年級實習生，已經在會計師事務所有兩年的工作經驗，這裡跟會計事務所死氣沉沉的工作氣氛完全不同，很享受在這工作環境!!! 在這裡又在更加強自己的會計實務經驗，重要的是學到了如何聰明有系統地把事情做好，及看到良好的公司文化經營。</p>

            <p>之前看了一位英國知名作家-Simon Sinek的一段演講影片，說著 understanding empathy 在工作環境上的重要性，是如何改變一個人的工作心態，讓每個人可以做自己。</p>
            <p>我覺得全公司都富有 empathy 這樣的良好環境，兩位老闆建立了一個很棒的辦公室文化，相信員工放手讓員工去做，提供各種支持讓員工有精神體力 .，例如 : 零食吧、健身補助、學習補助、各種活動...等，這文化也間接影響了在這的所有員工，每個人會互相關心互相體諒，實習這段期間完全沒有聽到任何互相責罵的聲音，犯錯可以勇於承認，大家會用幫助來取代責罵、累了就休息不用在意跟別人比較誰比較精實，大家可以很舒服地做自己，所以員工相對可以很安心為公司付出，只要在時間內完成好自己的任務就行，在這工作簡直就在像家一樣自在。</p>

            <p>真的覺得很榮幸可以在這工作，是值得向朋友炫耀不會掉漆的工作。</p>
        `,
    },
    {
        name: "SOPHIA",
        position: "Administrator",
        img: sophia,
        photo: sophiaPhoto,
        article: `
            <p>嗨大家，我是 Sophia</p>

            <p>在新芽的這些日子裡，主要是負責執行行政上的任務！如果午餐吃不到、螢幕壞掉了、零食飲料又沒了，通通可以找我解決~</p>

            <p>我就像待在辦公室的小小業務，我的客戶就是所有的夥伴們。
            協助新芽的大家，讓大家可以在舒適及充滿點心（這很重要）的環境下工作，是我的使命！</p>

            <p>我非常開心進入新芽成為大家的最佳小幫手，
            每次也都非常期待舉辦公司的大小活動，像是每月的慶生會、每年的週年慶、運動會、員工旅遊及尾牙
            讓大家在工作之餘能享受這樣的活動，是新芽最棒的福利。</p>
            
            <p>在實習的一年中，我學習到處理事情必須有完整的規劃
            當主管把事情交付予你之後，你必須開始思考怎麼規劃時程、安排進度，讓自己不會在多樣事情中手忙腳亂。
            你可能會有犯錯的可能，但不要太過慌張，新芽的所有人都會協助你更重要的是主管會引導你到正確的方向。</p>

            <p>最印象深刻的是，新芽每年的國內 outing 都會讓每個人上台分享一年中的工作經驗，以及接下來想要學習的新事物，
            讓公司內的所有人都了解你的想法，能有一起共同前進的目標。</p>

            <p>喜歡新芽的你們，快快加入我們讓我們一起為夢想前進吧！</p>
        `,
    },
    {
        name: "JIUDI",
        position: "Administrator",
        img: jiudi,
        photo: jiudiPhoto,
        article: `
            <p>嗨 我是 Jiudi，在新芽是屬於後勤團隊的行政。</p>

            <p>和一般實習生比較不一樣的是，我已經當過一年多的正職 PM ，
            但因為生涯規劃的考量，因此必須選擇非全職的工作。</p>

            <p>
            行政的工作內容並不複雜，但對於公司夥伴的工作品質有很大的影響力，
            如果公司有一支等級很高的行政團隊，大家其實不太會注意到這個團隊做了什麼事情，
            因為行政最重要的的目標是「讓所有人都能夠專注的在前線奮戰」。</p>

            <p>工作環境的管理是會隨著公司營運變化而需要被調整的，但要團隊要如何快速地適應轉換的陣痛期，
            就是一門非常值得學習的課程，這點新芽帶給我很驚豔的體驗。</p>

            <p>行政團隊當時面臨這樣的狀況時，除了留心在執行上的各種困難，領導人調整管理方式的執行力更是驚人，
            因此我們很快的就適應了陣痛期，這點到現在還是讓我十分敬佩。</p>
            
            <p>這個職位的經驗可能無法在你的履歷上增添多絢麗的光彩，但絕對可以培養你的觀察力和敏銳度，習得這項軟技能保證終身受用 :D</p>
        `,
    },
];



// WEBPACK FOOTER //
// ./src/models/Sprouters2018.js